import React from 'react';
import cn from '../../utils/cn';

function ReloadButton({
    onClick,
    width = 'w-8',
    height = 'h-8',
    disabled = false,
    className = ''
}) {
    return (
        <button
            type="button"
            onClick={onClick}
            disabled={disabled}
            className={cn(
                `rounded-lg overflow-hidden block text-[#14B9FF] hover:text-white bg-white hover:bg-[#14B9FF] transition-colors disabled:grayscale disabled:pointer-events-none disabled:cursor-default`,
                className,
                height,
                width
            )}
        >
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 31 31"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
            >
                <rect width="100%" height="100%" rx="0" fill="bg-white" fillOpacity="0.1" />
                <path
                    d="M15.4998 17.2792C16.4159 17.2792 17.1586 16.5101 17.1586 15.5614C17.1586 14.6126 16.4159 13.8435 15.4998 13.8435C14.5837 13.8435 13.8411 14.6126 13.8411 15.5614C13.8411 16.5101 14.5837 17.2792 15.4998 17.2792Z"
                    fill="currentColor"
                    fillOpacity="0.7"
                />
                <path
                    d="M16.5706 5.7744C16.1212 5.70596 15.6851 5.67859 15.2687 5.67859C10.755 5.67859 8.36933 9.27853 8.36933 9.27853C7.29213 10.7021 6.67091 12.4747 6.47266 14.5621H9.4201C9.59193 12.5979 10.4444 10.9895 12.1098 9.8808C14.7466 8.12189 17.3042 8.48463 19.7229 10.4831C20.3375 9.73708 20.9654 8.97739 21.5932 8.21087C20.3177 6.94473 18.5334 6.01394 16.5706 5.7744Z"
                    fill="currentColor"
                />
                <path
                    d="M10.7417 15.5476C10.6161 15.5476 10.4906 15.5476 10.365 15.5476C10.1535 15.5476 9.94205 15.5476 9.72396 15.5476H6.12227C5.88436 15.5476 5.63984 15.5476 5.39532 15.5476C5.13758 15.5408 4.94593 15.6297 4.83359 15.8761C4.72785 16.1225 4.80715 16.321 4.97237 16.5126C5.43497 17.0533 5.89097 17.6008 6.34696 18.1483C6.90208 18.8122 7.46382 19.4761 8.05198 20.1741C8.08503 20.1262 8.09824 20.0852 8.12468 20.051C8.89128 19.1339 9.66449 18.2168 10.4311 17.2997C10.6624 17.0191 10.9003 16.7453 11.1316 16.4647C11.2836 16.2868 11.3232 16.0814 11.2241 15.8624C11.1316 15.6571 10.9664 15.5476 10.7417 15.5476Z"
                    fill="currentColor"
                    fillOpacity="0.7"
                />
                <path
                    d="M14.4293 25.3482C14.8787 25.4167 15.3148 25.444 15.7312 25.444C20.2382 25.444 22.6306 21.8441 22.6306 21.8441C23.7078 20.4274 24.3224 18.648 24.5272 16.5605H21.5864C21.4146 18.5248 20.5621 20.1331 18.8967 21.2418C16.2599 23.0007 13.7023 22.638 11.2836 20.6396C10.669 21.3856 10.0411 22.1452 9.41333 22.9118C10.6822 24.1779 12.4665 25.1087 14.4293 25.3482Z"
                    fill="currentColor"
                />
                <path
                    d="M20.2582 15.575C20.3838 15.575 20.5094 15.575 20.6349 15.575C20.8464 15.575 21.0579 15.575 21.276 15.575H24.8777C25.1156 15.575 25.3601 15.575 25.6046 15.575C25.8623 15.5819 26.054 15.4929 26.1663 15.2465C26.2721 15.0001 26.1928 14.8017 26.0276 14.61C25.565 14.0693 25.109 13.5218 24.653 12.9743C24.0978 12.3104 23.5361 11.6466 22.9479 10.9485C22.9149 10.9964 22.9017 11.0375 22.8753 11.0717C22.1087 11.9888 21.3354 12.9059 20.5688 13.823C20.3375 14.1036 20.0996 14.3773 19.8683 14.6579C19.7163 14.8359 19.6767 15.0412 19.7758 15.2602C19.8683 15.4655 20.0335 15.575 20.2582 15.575Z"
                    fill="currentColor"
                    fillOpacity="0.7"
                />
            </svg>
        </button>
    );
}

export default ReloadButton;
